import ApiClient from "@/api/clients/ApiClient";
import Locales from "@/utils/locales";
import { i18n } from "vue-lang-router";
import { AxiosRequestConfig } from "axios";

export default class QorusClient extends ApiClient {
  public static client = QorusClient.of();

  private constructor() {
    const QORUS_PORT = process.env.VUE_APP_QORUS_PORT ? ":" + process.env.VUE_APP_QORUS_PORT : "";

    super({
      baseURL: process.env.VUE_APP_QORUS_HTTP_VERSION + "://" + process.env.VUE_APP_QORUS_HOST + QORUS_PORT + process.env.VUE_APP_QORUS_API_ROUTE,
      headers: {
        Accept: "application/json",
        common: {
          "Authorization": "Bearer " + process.env.VUE_APP_QORUS_API_KEY,
        },
      },
      withCredentials: true
    });

    this._axiosInstance.interceptors.request.use((config: AxiosRequestConfig) => {
      config.params = config.params || {};
      config.params.locale = encodeURIComponent(Locales.getLocaleCode(i18n.locale));

      return config;
    });
  }

  protected static of(): QorusClient {
    return new QorusClient();
  }
}
